import SNGPCModel from "@/models/sngpc/sngpcModel";
import { getPaginationParams } from "@/utils/common/http";
import nfetch from "@/utils/events/nfetch";

import { IService } from "../base/iService";

class SNGPCService extends IService<SNGPCModel> {
    constructor() {
        super("Sngpc");
    }

    public getSNGPCAtual(dataInicio: Date, dataFinal: Date, gerarInventario: boolean): Promise<Response> {
        const dataInicioString = new Date(dataInicio).toISOString();
        const dataFinalString = new Date(dataFinal).toISOString();

        return nfetch(
            `/${this.controllerName}/GetSNGPCAtual?dataInicio=${dataInicioString}&dataFinal=${dataFinalString}&gerarInventario=${gerarInventario}`,
            {
                credentials: "same-origin",
            },
        );
    }

    public getDataXml(id: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/Download?id=${id}`, {
            credentials: "same-origin",
        });
    }

    public enviarRelatorio(id: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/EnviarRelatorio?id=${id}`, {
            credentials: "same-origin",
        });
    }

    public getProximoPeriodo(gerarInventario: boolean): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetProximoPeriodo?&gerarInventario=${gerarInventario}`, {
            credentials: "same-origin",
        });
    }

    public getProdutos(sngpcId: number): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetProdutos?sngpcId=${sngpcId}`, {
            credentials: "same-origin",
        });
    }

    public listWithFilter(
        filterKey: string,
        sortKey: string,
        sortOrder: string,
        pageIndex: number,
        pageSize: number,
        status: number,
    ): Promise<Response> {
        const pagination = getPaginationParams(filterKey, sortKey, sortOrder, pageIndex, pageSize);

        return nfetch(`/${this.controllerName}/ListWithFilter?${pagination}` + `&status=${status}`, {
            credentials: "same-origin",
        });
    }

    public updateQuantidadeDetalhe(sngpcProdutoDetalheId: number, quantidade: number): Promise<Response> {
        return nfetch(
            `/${this.controllerName}/UpdateQuantidadeDetalhe?sngpcProdutoDetalheId=${sngpcProdutoDetalheId}&quantidade=${quantidade}`,
            {
                credentials: "same-origin",
                method: "POST",
            },
        );
    }
}

export default new SNGPCService();
